function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleantalklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-cleantalk",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cleantalk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color3, #fff)"
    },
    d: "M8.17 0.601c4 0.196 7.084 3.598 6.888 7.598-0.098 2-0.997 3.771-2.373 5.018l1.731 1.469-3.618-0.23c-1.014 0.459-2.15 0.69-3.339 0.632-4-0.196-7.084-3.598-6.888-7.598s3.598-7.084 7.598-6.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#339ebf",
    style: {
      fill: "var(--color34, #339ebf)"
    },
    d: "M8.194 0.096c2.139 0.105 4.034 1.067 5.368 2.539s2.106 3.45 2.001 5.588c-0.051 1.050-0.309 2.041-0.732 2.935-0.356 0.752-0.829 1.437-1.396 2.032l2.472 2.097-5.017-0.319c-0.515 0.223-1.060 0.392-1.628 0.499-0.581 0.11-1.185 0.155-1.803 0.126l0 0.001h-0l-0.024-0.002c-2.139-0.105-4.034-1.067-5.368-2.539-1.329-1.465-2.1-3.435-2.002-5.564h-0.001v-0l0.002-0.024c0.105-2.139 1.067-4.034 2.539-5.368 1.465-1.329 3.435-2.1 5.564-2.002v-0.001h0zM12.814 3.311c-1.154-1.273-2.793-2.108-4.644-2.205v0.001h-0l-0.024-0.002c-1.862-0.091-3.585 0.58-4.864 1.74-1.273 1.154-2.108 2.793-2.205 4.644h0.001v0l-0.002 0.024c-0.091 1.862 0.58 3.584 1.74 4.864 1.154 1.273 2.793 2.108 4.644 2.205l0-0.001h0l0.024 0.002c0.545 0.027 1.079-0.012 1.593-0.109 0.527-0.1 1.034-0.262 1.514-0.479l0.114-0.051 2.222 0.141-1.007-0.854 0.427-0.387c0.65-0.59 1.187-1.307 1.57-2.116 0.368-0.778 0.592-1.639 0.637-2.551 0.091-1.862-0.58-3.585-1.74-4.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4ac73b",
    style: {
      fill: "var(--color35, #4ac73b)"
    },
    d: "M7.787 6.257c0.873 0 1.58 0.708 1.58 1.581s-0.708 1.581-1.581 1.581c-0.873 0-1.581-0.708-1.581-1.581s0.708-1.581 1.581-1.581z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleantalklogo);
export default __webpack_public_path__ + "static/media/cleantalklogo.bfa8659c3183e9762370cd19f8dcc80b.svg";
export { ForwardRef as ReactComponent };